import { Button, Col, Modal, Row } from "react-bootstrap";
import { OrderItemSummary } from "../../../types/Order/orderItemSummary";
import { StyledModalTitle } from "../../../@ui/StyledModalTitle";
import styled from "styled-components";
import WfsParametersDisplay from "./WfsParametersDisplay";
import Price from "../../../@ui/Price";
import ThemedModal from "../../../@ui/Modal/ThemedModal";

export interface OrderItemModalProps {
  orderItemSummary: OrderItemSummary;
  wfsParameters: any;
  onDownloadClick: (orderItem: OrderItemSummary) => void;
  viewInvoice: (orderItem: OrderItemSummary) => void;
  onClose: () => void;
}

const Section = styled.div`
  padding-top: 0.5rem;
  border-top: 1px solid #ccc;
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;

const OrderItemModal = ({
  orderItemSummary,
  wfsParameters,
  viewInvoice,
  onDownloadClick,
  onClose,
}: OrderItemModalProps) => {
  return (
    <ThemedModal
      onHide={onClose}
      centered
      scrollable
      show={orderItemSummary != null}>
      <Modal.Header className="bg-secondary  text-white" closeButton>
        <StyledModalTitle>Order Details</StyledModalTitle>
      </Modal.Header>
      <Modal.Body className="overflow-auto bg-light">
        <div className="d-flex flex-column gap-1">
          <Row>
            <Col md="3">Order ID</Col>
            <Col md="9">{orderItemSummary.orderId}</Col>
          </Row>
          <Row>
            <Col md="3">User</Col>
            <Col md="9">{orderItemSummary.userFullName}</Col>
          </Row>{" "}
          <Row>
            <Col md="3">Order Date</Col>
            <Col md="9">
              {orderItemSummary.orderDate.toFormat("dd/MM/yyyy HH:mm")}
            </Col>
          </Row>
          <Row>
            <Col md="3">Product</Col>
            <Col md="9">{orderItemSummary.product}</Col>
          </Row>
          {orderItemSummary.featuresRequested && <Row>
            <Col md="3">Features Requested</Col>
            <Col md="9">{orderItemSummary.featuresRequested}</Col>
          </Row>}
          <Row>
            <Col md="3">Status</Col>
            <Col md="9">
              {orderItemSummary.status}{" "}
              {orderItemSummary.status === "In Progress" &&
              orderItemSummary.progress !== undefined
                ? ` - ${Math.round(orderItemSummary.progress * 100)}%`
                : ""}
            </Col>
          </Row>
          <Row>
            <Col md="3">Data expiry</Col>
            <Col md="9">
              {orderItemSummary.dataExpiry?.toFormat("dd/MM/yyyy")}
            </Col>
          </Row>
          <Section>
            <WfsParametersDisplay
              areaDescription={orderItemSummary.area}
              wfsParameters={wfsParameters}
            />
          </Section>
          <Section>
            <Row>
              <Col md="3">Subtotal</Col>
              <Col md="9">
                <Price
                  currencyCode={orderItemSummary.transactionCurrencyCode}
                  price={orderItemSummary.priceExTax}
                />
              </Col>
            </Row>
            <Row>
              <Col md="3">Tax</Col>
              <Col md="9">
                <Price
                  currencyCode={orderItemSummary.transactionCurrencyCode}
                  price={
                    orderItemSummary.priceIncTax - orderItemSummary.priceExTax
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col md="3">
                <strong>Total</strong>
              </Col>
              <Col md="9">
                <strong>
                  <Price
                    currencyCode={orderItemSummary.transactionCurrencyCode}
                    price={orderItemSummary.priceIncTax}
                  />
                </strong>
              </Col>
            </Row>
          </Section>
        </div>
      </Modal.Body>
      <Modal.Footer>
        {orderItemSummary.dataExpiry &&
          orderItemSummary.dataExpiry.diffNow().milliseconds > 0 && (
            <Button
              variant="primary"
              onClick={() => onDownloadClick(orderItemSummary)}>
              Download Data
            </Button>
          )}
        {orderItemSummary?.invoiceUrl && (
          <Button
            variant="primary"
            onClick={() => viewInvoice(orderItemSummary)}>
            View Invoice
          </Button>
        )}
      </Modal.Footer>
    </ThemedModal>
  );
};

export default OrderItemModal;
